/// Menu
import MetisMenu from "metismenujs";
import React, { Component, useContext, useEffect, useState } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";
import useScrollPosition from "use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext/ThemeContext";
import { useLanguage } from "../../../context/language/LanguageContext";
import { useFilter } from "../../../context/filter/FilterContext";
import { useDonor } from "../../../context/donor/donor.context";
import { Modal } from "react-bootstrap";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

const datePickerTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#b0000d",
    },
  },
});
class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }
  componentWillUnmount() {
    //  this.mm("dispose");
    // console.log(this.mm);
  }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const SideBar = () => {
  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
  } = useContext(ThemeContext);
  const { language } = useLanguage();
  const { t } = useTranslation();
  const { updateFilter } = useFilter();
  const {
    fetchDonorsGenderStatistics,
    fetchDonorsAgeStatistics,
    fetchDonorsGenderAgeStatistics,
    fetchBloodGroupStatistics,
    fetchDonorGenderBloodGroupStatistics,
    fetchDonorCountPerCollectionSite,
  } = useDonor();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [showDateModal, setShowDateModal] = useState(false);
  const [isDateBtnHovered, setIsDateBtnHovered] = useState(false);

  // Function to apply date filter and fetch all chart data
  const applyDateFilter = () => {
    const filter = {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    };

    // Update filter context
    updateFilter("dateRange", { start: startDate, end: endDate });

    // Fetch all chart statistics with the date filter
    fetchDonorsGenderStatistics(filter);
    fetchDonorsAgeStatistics(filter);
    fetchDonorsGenderAgeStatistics(filter);
    fetchBloodGroupStatistics(filter);
    fetchDonorGenderBloodGroupStatistics(filter);
    fetchDonorCountPerCollectionSite(filter);

    setShowDateModal(false);
  };
  useEffect(() => {
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);
	
	//sidebar icon Heart blast
	// var handleheartBlast = document.querySelector('.heart');
  //       function heartBlast() {
  //           return handleheartBlast.classList.toggle("heart-blast");
  //       }

  //       handleheartBlast.addEventListener('click', heartBlast);
	
  }, []);
  let scrollPosition = useScrollPosition();
  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  /// Active menu
  let deshBoard = [
      "",
      "dashboard-dark",
      "coin-details",
      "my-wallets",
      "transactions",
      "portofolio",
      "market-capital",
    ],
    app = [
      "app-profile",
      "post-details",
      "app-calender",
      "email-compose",
      "email-inbox",
      "email-read",
      "ecom-product-grid",
      "ecom-product-list",
      "ecom-product-order",
      "ecom-checkout",
      "ecom-invoice",
      "ecom-customers",
      "post-details",
      "ecom-product-detail",
    ],
    email = ["email-compose", "email-inbox", "email-read"],
    shop = [
      "ecom-product-grid",
      "ecom-product-list",
      "ecom-product-list",
      "ecom-product-order",
      "ecom-checkout",
      "ecom-invoice",
      "ecom-customers",
      "ecom-product-detail",
    ],
    charts = [
      "chart-rechart",
      "chart-flot",
      "chart-chartjs",
      "chart-chartist",
      "chart-sparkline",
      "chart-apexchart",
    ],
    bootstrap = [
      "ui-accordion",
      "ui-badge",
      "ui-alert",
      "ui-button",
      "ui-modal",
      "ui-button-group",
      "ui-list-group",
      "ui-media-object",
      "ui-card",
      "ui-carousel",
      "ui-dropdown",
      "ui-popover",
      "ui-progressbar",
      "ui-tab",
      "ui-typography",
      "ui-pagination",
      "ui-grid",
    ],
    plugins = [
      "uc-select2",
      "uc-nestable",
      "uc-sweetalert",
      "uc-toastr",
      "uc-noui-slider",
      "map-jqvmap",
    ],
    widget = ["widget-basic"],
    forms = [
      "form-element",
      "form-wizard",
      "form-editor-summernote",
      "form-pickers",
      "form-validation-jquery",
    ],
    table = ["table-bootstrap-basic", "table-datatable-basic"],
    pages = [
      "page-register",
      "page-login",
      "page-lock-screen",
      "page-error-400",
      "page-error-403",
      "page-error-404",
      "page-error-500",
      "page-error-503",
    ],
    error = [
      "page-error-400",
      "page-error-403",
      "page-error-404",
      "page-error-500",
      "page-error-503",
    ];
  return (
    <div
      className={`deznav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? scrollPosition > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <PerfectScrollbar className="deznav-scroll">
        <MM className="metismenu" id="menu">
        <li className={`mm-active`}>
            <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
              <i className="flaticon-381-networking"></i>
              <span className="nav-text">{t("filters.title")}</span>
            </Link>
            <ul aria-expanded="false" className="filter-menu">
              {/* Date Range Picker - First Filter */}
              <li className="filter-item date-filter-item">
                <button
                  type="button"
                  className="btn  btn-sm btn-block date-range-btn"
                  onMouseEnter={() => setIsDateBtnHovered(true)}
                  onMouseLeave={() => setIsDateBtnHovered(false)}
                  style={{
                    borderColor: isDateBtnHovered ? 'var(--primary)' : '',
                    boxShadow: isDateBtnHovered ? '0 4px 12px rgba(176, 0, 13, 0.15)' : ''
                  }}
                  onClick={() => setShowDateModal(true)}
                >
                  <div className="date-range-btn-icon">
                    <i className="fa fa-calendar-alt"></i>
                  </div>
                  <div className="date-range-btn-content">
                    <span className="date-range-btn-label">{t("filters.dateRange")}</span>
                    <div className="date-range-btn-values" dir="ltr">
                      <span className="date-value">
                        {format(startDate, "dd MMMM yyyy")}
                      </span>
                      <span className="date-separator">→</span>
                      <span className="date-value">
                        {format(endDate, "dd MMMM yyyy")}
                      </span>
                    </div>
                  </div>
                  <div className="date-range-btn-arrow">
                    <i className={`fa ${language === "ar" ? "fa-chevron-left" : "fa-chevron-right"}`}></i>
                  </div>
                </button>
              </li>

              {/* Date Range Modal */}
              <Modal
                show={showDateModal}
                onHide={() => setShowDateModal(false)}
                centered
                className="date-range-modal"
                dir={language === "ar" ? "rtl" : "ltr"}
              >
                <Modal.Header closeButton style={language === "ar" ? { flexDirection: 'row-reverse' } : {}}>
                  <Modal.Title>{t("filters.selectDateRange")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <ThemeProvider theme={datePickerTheme}>
                      <div className="mui-date-picker-container">
                        <div className="date-picker-field">
                          <label className="date-picker-label">{t("Start Date")}</label>
                          <KeyboardDatePicker
                            disableToolbar
                            variant="inline"
                            inputVariant="outlined"
                            format="dd/MM/yyyy"
                            value={startDate}
                            onChange={(date) => setStartDate(date)}
                            KeyboardButtonProps={{
                              "aria-label": "change start date",
                            }}
                            fullWidth
                            size="small"
                          />
                        </div>
                        <div className="date-picker-field">
                          <label className="date-picker-label">{t("End Date")}</label>
                          <KeyboardDatePicker
                            disableToolbar
                            variant="inline"
                            inputVariant="outlined"
                            format="dd/MM/yyyy"
                            value={endDate}
                            onChange={(date) => setEndDate(date)}
                            minDate={startDate}
                            KeyboardButtonProps={{
                              "aria-label": "change end date",
                            }}
                            fullWidth
                            size="small"
                          />
                        </div>
                      </div>
                    </ThemeProvider>
                  </MuiPickersUtilsProvider>
                </Modal.Body>
                <Modal.Footer style={language === "ar" ? { flexDirection: 'row-reverse', justifyContent: 'flex-start' } : {}}>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => setShowDateModal(false)}
                  >
                    {t("filters.cancel")}
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={applyDateFilter}
                  >
                    {t("filters.apply")}
                  </button>
                </Modal.Footer>
              </Modal>

              {/* Divider */}
              <li className="filter-divider"></li>

              {/* Center */}
              <li className="filter-item">
                <label className="filter-label">
                  {t("filters.center")}
                </label>
                <input
                  className="form-control filter-input"
                  type="text"
                  placeholder={t("filters.enterCenter")}
                />
              </li>

              {/* Collection Sites */}
              <li className="filter-item">
                <label className="filter-label">
                  {t("filters.collectionSites")}
                </label>
                <input
                  className="form-control filter-input"
                  type="text"
                  placeholder={t("filters.enterCollectionSite")}
                />
              </li>

              {/* Blood Group */}
              <li className="filter-item">
                <label className="filter-label">
                  {t("filters.bloodGroup")}
                </label>
                <select defaultValue="" className="form-control filter-select">
                  <option value="" disabled>{t("filters.selectBloodGroup")}</option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                </select>
              </li>

              {/* Age */}
              <li className="filter-item">
                <label className="filter-label">
                  {t("filters.ageRange")}
                </label>
                <div className="age-range-inputs">
                  <input
                    className="form-control filter-input"
                    type="number"
                    placeholder={t("filters.min")}
                    min="0"
                  />
                  <span className="age-separator">-</span>
                  <input
                    className="form-control filter-input"
                    type="number"
                    placeholder={t("filters.max")}
                    min="0"
                  />
                </div>
              </li>

              {/* State */}
              <li className="filter-item">
                <label className="filter-label">
                  {t("filters.state")}
                </label>
                <select defaultValue="" className="form-control filter-select">
                  <option value="" disabled>{t("filters.selectState")}</option>
                  <option value="regular">{t("filters.regular")}</option>
                  <option value="irregular">{t("filters.irregular")}</option>
                </select>
              </li>

              {/* BarCode */}
              <li className="filter-item">
                <label className="filter-label">
                  {t("filters.barcode")}
                </label>
                <input
                  className="form-control filter-input"
                  type="text"
                  placeholder={t("filters.enterBarcode")}
                />
              </li>

              {/* Bag Type */}
              <li className="filter-item">
                <label className="filter-label">
                  {t("filters.bagType")}
                </label>
                <select defaultValue="" className="form-control filter-select">
                  <option value="" disabled>{t("filters.selectBagType")}</option>
                  <option value="single">{t("filters.single")}</option>
                  <option value="double">{t("filters.double")}</option>
                  <option value="triple">{t("filters.triple")}</option>
                  <option value="quadruple">{t("filters.quadruple")}</option>
                </select>
              </li>

              {/* Donation Type */}
              <li className="filter-item">
                <label className="filter-label">
                  {t("filters.donationType")}
                </label>
                <select defaultValue="" className="form-control filter-select">
                  <option value="" disabled>{t("filters.selectDonationType")}</option>
                  <option value="voluntary">{t("filters.voluntary")}</option>
                  <option value="replacement">{t("filters.replacement")}</option>
                  <option value="directed">{t("filters.directed")}</option>
                </select>
              </li>

              {/* Sub Donation Type */}
              <li className="filter-item">
                <label className="filter-label">
                  {t("filters.subDonationType")}
                </label>
                <select defaultValue="" className="form-control filter-select">
                  <option value="" disabled>{t("filters.selectSubType")}</option>
                  <option value="wholeBlood">{t("filters.wholeBlood")}</option>
                  <option value="apheresis">{t("filters.apheresis")}</option>
                  <option value="autologous">{t("filters.autologous")}</option>
                </select>
              </li>

              {/* Gender */}
              {/* <li className="filter-item">
                <label className="filter-label">
                  {t("filters.gender")}
                </label>
                <div className="gender-radio-group" >
                  <label className="radio-option" >
                    <input type="radio" name="gender" value="male" />
                    <span className="radio-label">{t("filters.male")}</span>
                  </label>
                  <label className="radio-option">
                    <input type="radio" name="gender" value="female" />
                    <span className="radio-label">{t("filters.female")}</span>
                  </label>
                  <label className="radio-option">
                    <input type="radio" name="gender" value="all" defaultChecked />
                    <span className="radio-label">{t("filters.all")}</span>
                  </label>
                </div>
              </li> */}

              {/* Action Buttons */}
              <li className="filter-actions" style={{marginTop:"10px"}}>
                <button className="btn btn-primary btn-sm btn-block filter-apply-btn">
                  <span>{t("filters.applyFilters")}</span>
                </button>
                <button className="btn btn-outline-secondary btn-sm btn-block filter-clear-btn">
                  <span>{t("filters.clearAll")}</span>
                </button>
              </li>
            </ul>
          </li>
          {/* <li className={`${deshBoard.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
              <i className="flaticon-381-networking"></i>
              <span className="nav-text">Dashboard</span>
            </Link>
            <ul aria-expanded="false">
              <li>
                <Link className={`${path === "" ? "mm-active" : ""}`} to="/">
                  Dashboard Light
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "dashboard-dark" ? "mm-active" : ""}`}
                  to="/dashboard-dark"
                >
                  Dashboard Dark
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "coin-details" ? "mm-active" : ""}`}
                  to="/coin-details"
                >
                  Coin Details
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "my-wallets" ? "mm-active" : ""}`}
                  to="/my-wallets"
                >
                  My Wallets
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "transactions" ? "mm-active" : ""}`}
                  to="/transactions"
                >
                  Transactions
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "portofolio" ? "mm-active" : ""}`}
                  to="/portofolio"
                >
                  Portofolio
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "market-capital" ? "mm-active" : ""}`}
                  to="/market-capital"
                >
                  Market Capital
                </Link>
              </li>
            </ul>
          </li>
          <li className={`${app.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
              <i className="flaticon-381-television"></i>
              <span className="nav-text">Apps</span>
            </Link>
            <ul aria-expanded="false">
              <li>
                <Link
                  className={`${path === "app-profile" ? "mm-active" : ""}`}
                  to="/app-profile"
                >
                  Profile
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "post-details" ? "mm-active" : ""}`}
                  to="/post-details"
                >
                  Post Details
                </Link>
              </li>
              <li className={`${email.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow" to="#" aria-expanded="false">
                  Email
                </Link>
                <ul
                  aria-expanded="false"
                  className={`${email.includes(path) ? "mm-show" : ""}`}
                >
                  <li>
                    <Link
                      className={`${
                        path === "email-compose" ? "mm-active" : ""
                      }`}
                      to="/email-compose"
                    >
                      Compose
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${path === "email-inbox" ? "mm-active" : ""}`}
                      to="/email-inbox"
                    >
                      Inbox
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${path === "email-read" ? "mm-active" : ""}`}
                      to="/email-read"
                    >
                      Read
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link
                  className={`${path === "app-calender" ? "mm-active" : ""}`}
                  to="/app-calender"
                >
                  Calendar
                </Link>
              </li>
              <li className={`${shop.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow" to="#" aria-expanded="false">
                  Shop
                </Link>
                <ul
                  aria-expanded="false"
                  className={`${shop.includes(path) ? "mm-show" : ""}`}
                >
                  <li>
                    <Link
                      className={`${
                        path === "ecom-product-grid" ? "mm-active" : ""
                      }`}
                      to="/ecom-product-grid"
                    >
                      Product Grid
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "ecom-product-list" ? "mm-active" : ""
                      }`}
                      to="/ecom-product-list"
                    >
                      Product List
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "ecom-product-detail" ? "mm-active" : ""
                      }`}
                      to="/ecom-product-detail"
                    >
                      Product Details
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "ecom-product-order" ? "mm-active" : ""
                      }`}
                      to="/ecom-product-order"
                    >
                      Order
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "ecom-checkout" ? "mm-active" : ""
                      }`}
                      to="/ecom-checkout"
                    >
                      Checkout
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "ecom-invoice" ? "mm-active" : ""
                      }`}
                      to="/ecom-invoice"
                    >
                      Invoice
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "ecom-customers" ? "mm-active" : ""
                      }`}
                      to="/ecom-customers"
                    >
                      Customers
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li className={`${charts.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
              <i className="flaticon-381-controls-3"></i>
              <span className="nav-text">Charts</span>
            </Link>
            <ul aria-expanded="false">
              <li>
                <Link
                  className={`${path === "chart-rechart" ? "mm-active" : ""}`}
                  to="/chart-rechart"
                >
                  RechartJs
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "chart-chartjs" ? "mm-active" : ""}`}
                  to="/chart-chartjs"
                >
                  Chartjs
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "chart-chartist" ? "mm-active" : ""}`}
                  to="/chart-chartist"
                >
                  Chartist
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "chart-sparkline" ? "mm-active" : ""}`}
                  to="/chart-sparkline"
                >
                  Sparkline
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "chart-apexchart" ? "mm-active" : ""}`}
                  to="/chart-apexchart"
                >
                  Apexchart
                </Link>
              </li>
            </ul>
          </li>
          <li className={`${bootstrap.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
              <i className="flaticon-381-internet"></i>
              <span className="nav-text">Bootstrap</span>
            </Link>
            <ul aria-expanded="false">
              <li>
                <Link
                  className={`${path === "ui-accordion" ? "mm-active" : ""}`}
                  to="/ui-accordion"
                >
                  Accordion
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-alert" ? "mm-active" : ""}`}
                  to="/ui-alert"
                >
                  Alert
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-badge" ? "mm-active" : ""}`}
                  to="/ui-badge"
                >
                  Badge
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-button" ? "mm-active" : ""}`}
                  to="/ui-button"
                >
                  Button
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-modal" ? "mm-active" : ""}`}
                  to="/ui-modal"
                >
                  Modal
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-button-group" ? "mm-active" : ""}`}
                  to="/ui-button-group"
                >
                  Button Group
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-list-group" ? "mm-active" : ""}`}
                  to="/ui-list-group"
                >
                  List Group
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-media-object" ? "mm-active" : ""}`}
                  to="/ui-media-object"
                >
                  Media Object
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-card" ? "mm-active" : ""}`}
                  to="/ui-card"
                >
                  Cards
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-carousel" ? "mm-active" : ""}`}
                  to="/ui-carousel"
                >
                  Carousel
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-dropdown" ? "mm-active" : ""}`}
                  to="/ui-dropdown"
                >
                  Dropdown
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-popover" ? "mm-active" : ""}`}
                  to="/ui-popover"
                >
                  Popover
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-progressbar" ? "mm-active" : ""}`}
                  to="/ui-progressbar"
                >
                  Progressbar
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-tab" ? "mm-active" : ""}`}
                  to="/ui-tab"
                >
                  Tab
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-typography" ? "mm-active" : ""}`}
                  to="/ui-typography"
                >
                  Typography
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-pagination" ? "mm-active" : ""}`}
                  to="/ui-pagination"
                >
                  Pagination
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "ui-grid" ? "mm-active" : ""}`}
                  to="/ui-grid"
                >
                  Grid
                </Link>
              </li>
            </ul>
          </li>
          <li className={`${plugins.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
              <i className="flaticon-381-heart"></i>
              <span className="nav-text">Plugins</span>
            </Link>
            <ul aria-expanded="false">
              <li>
                <Link
                  className={`${path === "uc-select2" ? "mm-active" : ""}`}
                  to="/uc-select2"
                >
                  Select 2
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "uc-nestable" ? "mm-active" : ""}`}
                  to="/uc-nestable"
                >
                  Nestedable
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "uc-noui-slider" ? "mm-active" : ""}`}
                  to="/uc-noui-slider"
                >
                  Noui Slider
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "uc-sweetalert" ? "mm-active" : ""}`}
                  to="/uc-sweetalert"
                >
                  Sweet Alert
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "uc-toastr" ? "mm-active" : ""}`}
                  to="/uc-toastr"
                >
                  Toastr
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "map-jqvmap" ? "mm-active" : ""}`}
                  to="/map-jqvmap"
                >
                  Jqv Map
                </Link>
              </li>
            </ul>
          </li>
          <li className={`${widget.includes(path) ? "mm-active" : ""}`}>
            <Link to="widget-basic" className="ai-icon" aria-expanded="false">
              <i className="flaticon-381-settings-2"></i>
              <span className="nav-text">Widget</span>
            </Link>
          </li>
          <li className={`${forms.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
              <i className="flaticon-381-notepad"></i>
              <span className="nav-text forms">Forms</span>
            </Link>
            <ul aria-expanded="false">
              <li>
                <Link
                  className={`${path === "form-element" ? "mm-active" : ""}`}
                  to="/form-element"
                >
                  Form Elements
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "form-wizard" ? "mm-active" : ""}`}
                  to="/form-wizard"
                >
                  Wizard
                </Link>
              </li>
              <li>
                <Link
                  className={`${
                    path === "form-editor-summernote" ? "mm-active" : ""
                  }`}
                  to="/form-editor-summernote"
                >
                  Summernote
                </Link>
              </li>
              <li>
                <Link
                  className={`${path === "form-pickers" ? "mm-active" : ""}`}
                  to="/form-pickers"
                >
                  Pickers
                </Link>
              </li>
              <li>
                <Link
                  className={`${
                    path === "form-validation-jquery" ? "mm-active" : ""
                  }`}
                  to="/form-validation-jquery"
                >
                  Jquery Validate
                </Link>
              </li>
            </ul>
          </li>
          <li className={`${table.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
              <i className="flaticon-381-network"></i>
              <span className="nav-text">Table</span>
            </Link>
            <ul aria-expanded="false">
              <li>
                <Link
                  className={`${
                    path === "table-bootstrap-basic" ? "mm-active" : ""
                  }`}
                  to="/table-bootstrap-basic"
                >
                  Bootstrap
                </Link>
              </li>
              <li>
                <Link
                  className={`${
                    path === "table-datatable-basic" ? "mm-active" : ""
                  }`}
                  to="/table-datatable-basic"
                >
                  Datatable
                </Link>
              </li>
            </ul>
          </li>
          <li className={`${pages.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow ai-icon" to="#" aria-expanded="false">
              <i className="flaticon-381-layer-1"></i>
              <span className="nav-text">Pages</span>
            </Link>
            <ul aria-expanded="false">
              <li>
                <Link to="/page-register">Register</Link>
              </li>
              <li>
                <Link to="/page-login">Login</Link>
              </li>
              <li className={`${error.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow" to="#" aria-expanded="false">
                  Error
                </Link>
                <ul aria-expanded="false">
                  <li>
                    <Link
                      className={`${
                        path === "page-error-400" ? "mm-active" : ""
                      }`}
                      to="/page-error-400"
                    >
                      Error 400
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "page-error-403" ? "mm-active" : ""
                      }`}
                      to="/page-error-403"
                    >
                      Error 403
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "page-error-404" ? "mm-active" : ""
                      }`}
                      to="/page-error-404"
                    >
                      Error 404
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "page-error-500" ? "mm-active" : ""
                      }`}
                      to="/page-error-500"
                    >
                      Error 500
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`${
                        path === "page-error-503" ? "mm-active" : ""
                      }`}
                      to="/page-error-503"
                    >
                      Error 503
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link
                  className={`${
                    path === "page-lock-screen" ? "mm-active" : ""
                  }`}
                  to="/page-lock-screen"
                >
                  Lock Screen
                </Link>
              </li>
            </ul>
          </li> */}
        </MM>
        {/* <div className="book-box">
          <img src={book} alt="" />
          <Link to="javascript:void(0);">Generate Report &gt;</Link>
        </div>
        <div className="copyright">
          <p>
            <strong>Kripton Crypto Admin Dashboard</strong> © 2021 All Rights
            Reserved
          </p>
          <p className="fs-12">
            Made with <span className="heart" /> by DexignZone
          </p>
        </div> */}
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
